var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuscar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_237_519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.00315 10.0051C6.15698 10.0065 7.27565 9.60736 8.16791 8.87559L11.1522 11.8596C11.351 12.0516 11.6676 12.046 11.8596 11.8472C12.0468 11.6533 12.0468 11.3461 11.8596 11.1522L8.87572 8.16774C10.6237 6.02822 10.3063 2.87685 8.16698 1.12877C6.0276 -0.619307 2.87643 -0.301943 1.1287 1.83757C-0.619267 3.97708 -0.301924 7.12845 1.83745 8.87653C2.73089 9.60666 3.84932 10.0054 5.00315 10.0051Z",
    fill: "#62C776"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_237_519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuscar);
export default __webpack_public_path__ + "static/media/buscar.84a38ef3c1b83f4dc325875d1576ad59.svg";
export { ForwardRef as ReactComponent };